import { useTranslation } from "react-i18next";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionDisclosureProps {
  article: ArticlePageArticle;
}

export function ArticleSectionDisclosure({
  article,
}: ArticleSectionDisclosureProps) {
  const { t } = useTranslation();
  const funding = article.funding;
  const disclosure = article.disclosure;

  if (!funding && !disclosure) return null;

  return (
    <section data-gtm-section="disclosure" data-gtm-order="9">
      <SectionTitle title={t("Disclosure")} className="mb-4" />
      <div className="mt-6 flex flex-col gap-3">
        {funding && (
          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-medium uppercase tracking-wide text-[#6a7282]">
              {t("Funding")}
            </h3>
            <p className="text-sm text-[#1e2939]">
              <ScientificText>{funding}</ScientificText>
            </p>
          </div>
        )}
        {disclosure && (
          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-medium uppercase tracking-wide text-[#6a7282]">
              {t("Conflicts of interest")}
            </h3>
            <p className="text-sm text-[#1e2939]">
              <ScientificText>{disclosure}</ScientificText>
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
